import { useState, useEffect } from 'react';

import { Carousel, Layout, Loading } from 'element-react';
import { useTranslation } from 'react-i18next';

import { API, Auth } from 'aws-amplify';
import { listCompanys, listProducts} from '../graphql/queries';
import userStore from '../store/user';
import RfqBackground from "../assets/imgs/bainub-RFQ.jpg";
import RfqLaptop from "../assets/imgs/rfq-laptop.png";

import checkIcon from "../assets/imgs/check-icon.svg";
import arrowIcon from "../assets/imgs/arrow-icon.svg";
import rfqStepIcon1 from "../assets/imgs/rfqStepIcon1.png"; 
import rfqStepIcon2 from "../assets/imgs/rfqStepIcon2.png";
import rfqStepIcon3 from "../assets/imgs/rfqStepIcon3.png";
import rfq from "../assets/imgs/rfqRequest.png";
import rfqDashboardIllustration from "../assets/imgs/DashboardOrders.png"; 

import iconCategory2 from "../assets/imgs/Icon_Category2.png";
import iconCategory3 from "../assets/imgs/Icon_Category3.png";
import iconCategory4 from "../assets/imgs/Icon_Category4.png";
import iconCategory5 from "../assets/imgs/Icon_Category5.png";
import iconCategory6 from "../assets/imgs/Icon_Category6.png";
import iconCategory7 from "../assets/imgs/Icon_Category7.png";

// Imagenes para el blog
import blogImage1 from '../assets/imgs/blog-image-1.png'; 
import blogImage2 from '../assets/imgs/blog-image-2.png'; 
import blogImage3 from '../assets/imgs/blog-image-3.png'; 

import WelcomeBanner from '../components/WelcomeBanner'
import HomeSlider from '../components/HomeSlider'
import HomeSliderInner from '../components/HomeSliderInner'
import SuppliersSwiper from '../components/SuppliersSwiper'
import ProductsSwiper from '../components/ProductsSwiper'
import { GRAPHQL_AUTH_MODE } from "@aws-amplify/api-graphql";
import RegisterSurvey from "./RegisterSurvery";
import surveyInfo from "../store/surveyStatus";
import PagerQuery from '../utils/PagerQuery';
import { Link } from "react-router-dom";
import {GET_PRODUTCS_URL, GET_SYSTEM_CONFIG_URL, GET_TOP_SEARCHES_URL, RFQ_API_URL , GET_PUBLIC_RFQS_URL } from '../utils/Constants';

// Importaciones para seccion de mas products
import ProductGridCard from '../components/ProductGridCard'; 

function Main() {
    const { t } = useTranslation();
    const { user } = userStore();
    const [[loading , setLoading], [loadingSuppliers , setLoadingSuppliers], [loadingFeaturedProducts , setLoadingFeaturedProducts], [loadingRecentlyAddedProducts , setLoadingRecentlyAddedProducts], [suppliers , setSuppliers], [featuredProducts , setFeaturedProducts], [recentlyAddedProducts , setRecentlyAddedProducts]]  = [useState(false), useState(false), useState(false), useState(false), useState([]), useState([]), useState([])]
    const [tamaulipasProducts, setTamaulipasProducts] = useState([]);
    const [loadingTamaulipasProducts, setLoadingTamaulipasProducts] = useState(false);
    const {surveyStatus, sessionSurveyStatus, setSessionSurveyStatus} = surveyInfo();
    const [surveyVisible, setSurveyVisible] = useState(false);
    const [userInfo, setUserInfo] = useState({});

    // -------- ESTADOS y DATOS PARA TOP SEARCH -------------------
    const [topSearches, setTopSearches] = useState([]);
    const [loadingTopSearches, setLoadingTopSearches] = useState(true);

    // useEffect para cargar las Top Searches
    useEffect(() => {
        const loadTopSearches = async () => {
            setLoadingTopSearches(true);
            try {
                const response = await fetch(GET_TOP_SEARCHES_URL);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                console.log("Top Searches data received:", data);
                setTopSearches(data);
            } catch (error) {
                console.error("Error fetching top searches:", error);
                setTopSearches([]); 
            } finally {
                setLoadingTopSearches(false);
            }
        };

        loadTopSearches();
    }, []);

    // -------- FIN DE TOP SEARCH ------------------------------

    // ======== DATOS Y ESTADOS PARA LA NUEVA SECCIÓN DE CATEGORÍAS ========
    // Estados que necesita
    const [categories, setCategories] = useState([]);
    const [productsByCategory, setProductsByCategory] = useState({});
    const [activeCategoryId, setActiveCategoryId] = useState(null);
    const [displayedProducts, setDisplayedProducts] = useState([]);
    const [productsLoading, setProductsLoading] = useState(true);
    // ESTADO PARA EL MENÚ MÓVIL
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    // === INICIO: CÓDIGO PARA RFQs ACTIVAS ===
    const [activeRfqs, setActiveRfqs] = useState([]);
    const [loadingRfqs, setLoadingRfqs] = useState(false);

    useEffect(() => {
        const loadActiveRfqs = async () => {
            setLoadingRfqs(true);
            try {
                // URL PÚBLICA sin token de autorización
                const response = await fetch(GET_PUBLIC_RFQS_URL);

                if (!response.ok) {
                    throw new Error('Failed to fetch public RFQs');
                }

                const data = await response.json();
                
                const filteredData = data.rfq
                    .filter(item => item.status === 1)
                    .sort((a, b) => b.id - a.id) 
                    .slice(0, 5);
                
                setActiveRfqs(filteredData);

            } catch (error) {
                console.error("Error cargando las RFQs públicas para el home:", error);
                setActiveRfqs([]); 
            } finally {
                setLoadingRfqs(false);
            }
        };

        loadActiveRfqs();
    }, []);
    // ==============================================

    // categorías y el valor por el cual se filtra
    const HOME_CATEGORIES = [
        { id: 'metal', name: 'METAL & METAL PRODUCTS', filterTags: ['bnbmp2506'] },
        { id: 'advertising', name: 'Advertising, Packaging & Printing', filterTags: ['bnbapp2506'] },
        { id: 'chemicals', name: 'Plastic & Rubber Products', filterTags: ['bnbpr2506'] },
        { id: 'electrical', name: 'Electrical & Electronics', filterTags: ['bnbee2506'] },
        { id: 'industrial', name: 'Industrial Equipment', filterTags: ['bnbie2506'] },
        
    ];

    // == logica para organización de productos ==
        const selectAndOrganizeProducts = (productsForCategory) => {
        //  Aleatorizar toda la lista de productos de la categoría.
        const shuffledProducts = shuffleArray([...productsForCategory]);

        const selectedProducts = [];
        const usedCompanyIds = new Set();

        // Intentar llenar los 6 espacios con productos de empresas únicas.
        for (const product of shuffledProducts) {
            if (selectedProducts.length >= 6) break;

            if (!usedCompanyIds.has(product.company_id)) {
                selectedProducts.push(product);
                usedCompanyIds.add(product.company_id);
            }
        }

        // Paso 3: Si no se llenaron los 6 espacios, rellenar con los productos restantes.
        if (selectedProducts.length < 6) {
            const remainingProducts = shuffledProducts.filter(p => 
                !selectedProducts.some(sp => sp.id === p.id)
            );
            
            let i = 0;
            while (selectedProducts.length < 6 && i < remainingProducts.length) {
                selectedProducts.push(remainingProducts[i]);
                i++;
            }
        }
        
        return selectedProducts;
    };

    // useEffect que se ejecuta una vez para cargar toda la data de esta sección
    useEffect(() => {
    const loadCategorySectionData = async () => {
        setProductsLoading(true);
        try {
            const productsResponse = await fetch(GET_PRODUTCS_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' } });
            const allProducts = await productsResponse.json();

            if (!allProducts || allProducts.length === 0) {
                console.error("ALERTA: La lista maestra de productos está vacía.");
                setProductsLoading(false);
                return;
            }

            const groupedProducts = {};
            for (const category of HOME_CATEGORIES) {
                
                const prodsForCategory = allProducts.filter(p => 
                    p.tags && Array.isArray(p.tags) && category.filterTags.some(tag => p.tags.includes(tag))
                );
                
                groupedProducts[category.id] = selectAndOrganizeProducts(prodsForCategory);
            }
            
            setCategories(HOME_CATEGORIES);
            setProductsByCategory(groupedProducts);

            if (HOME_CATEGORIES.length > 0) {
                setActiveCategoryId(HOME_CATEGORIES[0].id);
            }

        } catch (error) {
            console.error("Error en loadCategorySectionData:", error);
        } finally {
            setProductsLoading(false);
        }
    };

    loadCategorySectionData();
}, []); 

    // useEffect que reacciona a los clics del usuario en las pestañas
    useEffect(() => {
        if (activeCategoryId && productsByCategory[activeCategoryId]) {
            setDisplayedProducts(productsByCategory[activeCategoryId]);
        }
    }, [activeCategoryId, productsByCategory]);
    // ======== FIN DATOS Y ESTADOS PARA CATEGORÍAS ========

    // ====> DATOS PARA LA SECCIÓN DEL BLOG
    const blogPosts = [
        {
            image: blogImage1, 
            title: 'What is a B2B Marketplace?',
            date: 'Aug 30, 2024',
            readTime: '2 min read',
            url: 'https://blog.bainub.com/post/what-is-a-marketplace-b2b',
        },
        {
            image: blogImage2, 
            title: 'Top 3 Mexican Metal Forming Manufacturers — Find the Best Solutions for Bending, Stamping & Punching',
            date: 'Jun 26, 2025',
            readTime: '4 min read',
            url: 'https://blog.bainub.com/post/top-3-mexican-metal-forming-manufacturers',
        },
        {
            image: blogImage3, 
            title: 'Top 5 Mexican CNC Machining Suppliers for Precision Metal Parts',
            date: 'Jun 26, 2025',
            readTime: '4 min read',
            url: 'https://blog.bainub.com/post/top-5-mexican-cnc-machining-suppliers-for-precision-metal-parts',
        }
    ];

    useEffect(function () {
        // setLoading(true)
        setLoadingSuppliers(true)
        loadSuppliers()
        setLoadingFeaturedProducts(true)
        loadFeaturedProducts()
        setLoadingRecentlyAddedProducts(true)
        //loadRecentlyAddedProducts()
        setSessionSurveyStatus(false);
        setUserInfo(user);
        if (!surveyStatus && !sessionSurveyStatus) {
            console.log("survey call")
            console.log(user)
            setTimeout(() => {setSurveyVisible(true)}, 3000);
            }}, [])

    async function loadSuppliers() {
        console.log("loading new suppliers ...");
        const input = { filter : { hidden : { eq : 0 } } } ;
        const pagerQuery = new PagerQuery(listCompanys, input, Object.keys({ listCompanys }));
        const suppliers = await pagerQuery.searchPublicData();
        //limit listCompanyes where published != 0 (to include 1 and null)
        suppliers.data.listCompanys.items = suppliers.data.listCompanys.items.filter((item) => item.published != 0);
        //order supliers by createdAt desc
        suppliers.data.listCompanys.items.sort((a, b) => (a.createdAt > b.createdAt) ? -1 : 1)
        setSuppliers(suppliers.data.listCompanys.items.slice(0,16))
        setLoadingSuppliers(false)
    }

    async function loadFeaturedProducts() {
        console.log("loading featured products ...");
        //const featuredProducts = await API.graphql({ query: listProducts, variables: { filter: { featured: { eq: 1 }, status : { eq: 1} }, limit: 10 }, authMode: GRAPHQL_AUTH_MODE.AWS_IAM  })
        //const input = { filter: { status : { eq: 1} } };
        //const pagerQuery = new PagerQuery(listProducts, input, Object.keys({ listProducts }));
        //let featuredProducts = await pagerQuery.searchPublicData();

        const response = await fetch(GET_PRODUTCS_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                //'Authorization': token
            }
        });
        const data = await response.json();
        console.log("::::: FEATURED PRODUCTS :::::");
        console.log({data});

        const responseFeatured = await fetch(GET_SYSTEM_CONFIG_URL + "web.products.home.featured", {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                //'Authorization': token
            }
        });
        const dataFeatured = await responseFeatured.json();
        console.log("::::: FEATURED PRODUCTS SYSTEM CONFIG :::::");
        console.log({dataFeatured});
        var arrayFeatured = dataFeatured[0].value.split("|");

        //let recentlyAddedProducts = featuredProducts;
        //console.log(featuredProducts)
        let lastList = data;
        //lastList = lastList.filter((item) => item.featured === 1);
        lastList = lastList.filter((item) => arrayFeatured.includes(item.id));
        console.log({lastList})
        shuffleArray(lastList);
        if(lastList.length > 6){
            setFeaturedProducts(limitOneByCompany(lastList))
        }
        else{
            setFeaturedProducts(lastList)
        }
            
        
        //data.sort((a, b) => (a.createdAt > b.createdAt) ? -1 : 1)
        //const _finalList = limitOneByCompany(data);

        const responseRecent = await fetch(GET_SYSTEM_CONFIG_URL + "web.products.home.recent", {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                //'Authorization': token
            }
        });
        const dataRecent = await responseRecent.json();
        console.log("::::: Recent PRODUCTS SYSTEM CONFIG :::::");
        console.log({dataRecent});
        var arrayRecent = dataRecent[0].value.split("|");
        const listRecent = data.filter((item) => arrayRecent.includes(item.id));
        setRecentlyAddedProducts(listRecent);

        // ===== Tamaulipas Products =====
        setLoadingTamaulipasProducts(true);
        // IDs en orden: primero Tecnologías Alternativas del Noreste, luego Jackie Solis Cosmetica Natural
        const tamaulipasProductIds = [
            '66743f7b-5c3e-4ae6-b333-a99020de23ac', // Milling Machining Parts
            'b8a13afa-37fb-4d45-83c2-e5926ed45d3f', // Lathe Machining Parts
            '4363f2fd-c5ad-4b3a-8d3b-e30fb2337ae4', // Natural Rosemary Hair Oil
            '604709cf-38f3-4a9f-9644-fc3bc4bc8411', // Nourishing Hair Mask
            'e8e54126-c2cf-4310-8479-fd4d6623661d', // Natural Rosemary Hair Tonic
            'ab8d38e8-18de-46e2-a158-0607d90284a7', // Rosemary Extract Conditioner
            '61372e36-0e82-496b-8099-4ce57bac0f9f', // Natural Rosemary Anti-Hair Loss Shampoo
        ];
        // Mapear los IDs para mantener el orden exacto
        const tamaulipasOrdered = tamaulipasProductIds
            .map(id => data.find(item => item.id === id))
            .filter(Boolean);
        setTamaulipasProducts(tamaulipasOrdered);
        setLoadingTamaulipasProducts(false);
        // ===== Fin Tamaulipas Products =====
    
        setLoadingFeaturedProducts(false)
        setLoadingRecentlyAddedProducts(false)
    }

    function limitOneByCompany(list){
        let _finalList = [];
        let _companyList = [];
        list.map((item) => {
            if(_companyList.length >= 6)
                return
            if(!_companyList.includes(item.company_id)){
                _companyList.push(item.company_id);
                _finalList.push(item);
            }
        })
        return _finalList;
    }


    function shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          // Swap array[i] and array[j]
          [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
      }

    async function loadRecentlyAddedProducts() {
        console.log("loading recently added products ...");
        //const recentlyAddedProducts = await API.graphql({ query: listProducts, variables: { limit: 10, filter: { status: { eq: 1 } } }, authMode: GRAPHQL_AUTH_MODE.AWS_IAM })
        // console.log(recentlyAddedProducts)
        const input = { filter: { status: { eq: 1 } } };
        const pagerQuery = new PagerQuery(listProducts, input, Object.keys({ listProducts }));
        const recentlyAddedProducts = await pagerQuery.searchPublicData();
        //order by createdAt
        recentlyAddedProducts.data.listProducts.items.sort((a, b) => (a.createdAt > b.createdAt) ? -1 : 1)
        setRecentlyAddedProducts(recentlyAddedProducts.data.listProducts.items.slice(0,6))
        setLoadingRecentlyAddedProducts(false)
    }

    if(loading)
        return <Loading text={t('general.loading')} loading={loading} fullscreen={true} />
    return(
        <>
            {/* Si no hay nombre de usuario (es un visitante) */}
            {
                !user.name ? (
            
            <Layout.Row justify="center" align="middle" className="home-banner-row">
                <Layout.Col xs="12" sm="24" md="16" lg="16" className='Banner-img' >
                    <HomeSlider />
                </Layout.Col>
                <Layout.Col xs="12" sm="24" md="8" lg="8" className='banner-text' >
                    <br></br>
                    <h2>Welcome to Bainub</h2>
                    <p>We facilitate the connection between companies looking to grow their digital sales and those seeking reliable and competitive suppliers.</p>
                    <p>Learn how Bainub works for you:</p>
                    {/*<a href="https://www.bainub.com/b2b-trading-platform" target='_blank' className='el-button el-button--secondary'>Learn More</a>*/}
                    <div className="home-banner-buttons">
                        <Link to="/buyer-tools" className="el-button banner-button-buy">
                            I WANT TO BUY
                        </Link>
                        <Link to="/seller-tools" className="el-button banner-button-sell">
                            I WANT TO SELL
                        </Link>
                    </div>
                </Layout.Col>
            </Layout.Row>
                ):( /* Cuando ya hizo login  */
            <Layout.Row>
                <Layout.Col>
                     <HomeSliderInner />
                </Layout.Col>
            </Layout.Row>)
            }
        {/*Seccion de Top-Searches */}
            <Layout.Row className='top-searches-padding'>
                <Layout.Row className='top-searches-flex-wrapper'>
                    <div className='top-searches-box-2'>
                        TOP SEARCHES:
                    </div>
                    {loadingTopSearches ? (
                        <Loading text={t('general.loading')} />
                    ) : (
                        topSearches.length > 0 ? (
                            <div className="top-searches-pills-container">
                                {topSearches.map((searchItem, index) => {
                                    // REVERTIDO a pasar searchItem.cleaned_message directamente, sin singularizar
                                    // AÑADIDO: Lógica específica para transformar "plastics" a "plastic" en la URL
                                    const searchTermForURL = searchItem.cleaned_message.toLowerCase() === 'plastics' 
                                        ? 'plastic' 
                                        : searchItem.cleaned_message;

                                    return (
                                        <Link 
                                            key={index} 
                                            to={`/search-result-ng/${encodeURIComponent(searchTermForURL)}/All?query=${encodeURIComponent(searchTermForURL)}`} 
                                            className="top-searches-link" 
                                        >
                                            <div
                                                className={'top-searches-box'}
                                            >
                                                {searchItem.cleaned_message} {/* Muestra el texto original (plural) */}
                                            </div>
                                        </Link>
                                    );
                                })}
                            </div>
                        ) : (
                            <p>No top searches to display.</p>
                        )
                    )}
                </Layout.Row>
            </Layout.Row>

            {/* =========== INICIO: Nueva Sección RFQ =========== */}
            <Layout.Row className="new-rfq-section responsivePadding">
                <Layout.Col xs="24" sm="24" md="11" lg="11" className="rfq-steps-left">
                    <h2>Source smarter, <br/>Get quotes faster</h2>

                    <div className="steps-container">
                        {/* --- Paso 1 --- */}
                        <div className="step-item">
                            <span className="step-number">1.</span>
                            <div className="step-icon-wrapper">
                                <img src={rfqStepIcon1} alt="Submit RFQ" />
                            </div>
                            <div className="step-text">
                                <p>Submit your RFQ.</p>
                                <p>Describe what you need.</p>
                            </div>
                        </div>
                        {/* --- Paso 2 --- */}
                        <div className="step-item">
                            <span className="step-number">2.</span>
                            <div className="step-icon-wrapper">
                                <img src={rfqStepIcon2} alt="Receive quotes" />
                            </div>
                            <div className="step-text">
                                <p>Receive quotes from qualified suppliers.</p>
                            </div>
                        </div>
                        {/* --- Paso 3 --- */}
                        <div className="step-item">
                            <span className="step-number">3.</span>
                            <div className="step-icon-wrapper">
                                <img src={rfqStepIcon3} alt="Compare and choose" />
                            </div>
                            <div className="step-text">
                                <p>Compare and choose the best fit for your business.</p>
                            </div>
                        </div>
                    </div>

                    <p className="rfq-footer-text"><b>The easiest way to find trusted suppliers.</b></p>
                    <Link to="/tools/rfq" className="el-button el-button--primary">CREATE AN RFQ</Link>
                    {
                        !user.name && (
                            <p className="rfq-signup-prompt">
                                *To create an RFQ, you need an account. <Link to="/register">Sign up for free!</Link>
                            </p>
                        )
                    }
                </Layout.Col>
                
                <Layout.Col xs="24" sm="24" md="13" lg="13" className="active-rfqs-right">
                    <div className="active-rfqs-box">
                        <h3>Active RFQs in Bainub</h3>
                        <div className="rfq-list">
                            {loadingRfqs ? (
                                <Loading text="Loading..." />
                            ) : (
                                activeRfqs.length > 0 ? (
                                    activeRfqs.map(rfq => (
                                        <Link key={rfq.id} 
                                            to={{
                                                pathname: `/rfq-details/${rfq.id}`,
                                                state: { isSellerView: true }
                                            }} 
                                            className="rfq-list-item-link">
                                            <div className="rfq-list-item">
                                                {rfq.product_name}
                                            </div>
                                        </Link>
                                    ))
                                ) : (
                                    <p className="no-rfqs-message"></p>
                                )
                            )}
                        </div>
                        <div className="rfq-buttons">
                            <Link to="/active-rfq" className="el-button el-button--default">VIEW ALL BUSSINESS OPORTUNITIES</Link>
                            
                        </div>
                    </div>
                </Layout.Col>
            </Layout.Row>
            {/* =========== FIN: Sección RFQ =========== */}

            <Layout.Row justify="center" align="middle" className="m-t-xs productsRow responsivePadding">
                <Layout.Col span="24">
                    <h2 className="primary-color">{t('home-page.featured-products')}</h2>
                </Layout.Col>
                <ProductsSwiper
                    spaceBetween={10}
                    slidesPerView={5}
                    products={featuredProducts}
                    loading={loadingFeaturedProducts}
                    />
            </Layout.Row>

            {/* =========== INICIO: Sección Tamaulipas Products =========== */}
            <Layout.Row justify="center" align="middle" className="m-t-xs productsRow responsivePadding">
                <Layout.Col span="24">
                    <h2 className="primary-color">Nearshore Manufacturing from Tamaulipas</h2>
                </Layout.Col>
                <ProductsSwiper
                    spaceBetween={10}
                    slidesPerView={5}
                    products={tamaulipasProducts}
                    loading={loadingTamaulipasProducts}
                    />
            </Layout.Row>
            {/* =========== FIN: Sección Tamaulipas Products =========== */}

            {/* =========== INICIO: Sección Explore More Categories =========== */}
            <Layout.Row justify="center" className="explore-categories-section responsivePadding">
                <Layout.Col span="24">
                    <Layout.Row gutter="30">
                        {/* --- Columna Izquierda: Lista de Categorías --- */}
                        <Layout.Col xs={24} sm={24} md={7} lg={8} >
                        <div className="explore-categories-header">
                            <div className="explore-categories-title-container">
                                <h2 className="explore-categories-main-title">
                                    {t('home-page.exploreCategories.title', 'Explore More Categories!')}
                                </h2>
                                <p className="explore-categories-subtitle">
                                    {t('home-page.exploreCategories.subtitle', 'Find the right suppliers for you')}
                                </p>
                            </div>

                            {/* Botón de hamburguesa (oculto en escritorio) */}
                            <button className="mobile-menu-toggle" onClick={() => setIsMobileMenuOpen(true)}>
                                <div className="hamburger-line"></div>
                                <div className="hamburger-line"></div>
                                <div className="hamburger-line"></div>
                            </button>
                        </div>
                        <div className={`category-list-column ${isMobileMenuOpen ? 'is-mobile-menu-open' : ''}`}>

                            <button className="mobile-menu-close" onClick={() => setIsMobileMenuOpen(false)}>&times;</button>
                            {categories.map((category) => (
                                <div
                                key={category.id}
                                className={`category-list-item ${activeCategoryId === category.id ? 'active' : ''}`}
                                onClick={() => {
                                    setActiveCategoryId(category.id);
                                    setIsMobileMenuOpen(false);
                                }}
                                >
                                    <span>{category.name}</span>
                                    <span className="category-arrow-icon">➔</span>
                                </div>
                            ))}
                        </div>
                        </Layout.Col>

                        {/* --- Columna Derecha: Grid de Productos --- */}
                        <Layout.Col xs={24} sm={24} md={17} lg={16} className="product-grid-column">
                            <h3 className="mobile-category-title">{categories.find(c => c.id === activeCategoryId)?.name}</h3>

                            {productsLoading ? (
                                <Loading text={t('general.loading')} />
                            ) : (
                                // Contenedor para el scroll horizontal
                                <div className="product-scroll-container">
                                    {displayedProducts.length > 0 ? displayedProducts.map((product) => (
                                        <div key={product.id} className="product-card-scroll-item">
                                            <ProductGridCard product={product} />
                                        </div>
                                    )) : (
                                        <p>{t('home-page.exploreCategories.noProducts', 'No products to display for this category yet.')}</p>
                                    )}
                                </div>
                            )}
                        </Layout.Col>
                    </Layout.Row>
                </Layout.Col>
            </Layout.Row>
            {/* =========== FIN: Sección Explore More Categories =========== */}

            <Layout.Row justify="center" align="middle" className="m-t-xs m-b-xl responsivePadding productsRow">
                <Layout.Col span="24">
                <h2 className="primary-color">{t('home-page.recently-added-products')}</h2>
                </Layout.Col>

                <ProductsSwiper
                    spaceBetween={10}
                    products={recentlyAddedProducts}
                    loading={loadingRecentlyAddedProducts}
                    />
            </Layout.Row>
            
            {/* =========== INICIO: Nueva Sección Quick RFQ =========== */}
            <Layout.Row className="quick-rfq-banner-top responsivePadding"> 
                <Layout.Col span="24" className='rfq-banner'>
                    <img src={checkIcon} className='check-icon' alt="" width="24px"/>
                    <h2 className="quick-rfq-main-title">
                        {t('home-page.quickRfq.mainTitle', 'Discover our Quick RFQ tool: Get the quotes you need in 3 easy steps.')}
                    </h2>
                </Layout.Col>
            </Layout.Row>

            <Layout.Row justify="center" align="top" className="quick-rfq-content-section responsivePadding">
                <Layout.Col xs="24" sm="24" md="12" lg="13" className="quick-rfq-steps-area">
                    <p className="quick-rfq-subtitle rfq-subtitle-desk">
                        {t('home-page.quickRfq.subtitle', 'Get the quotes you need—fast.')}
                    </p>
                    <p className="quick-rfq-subtitle rfq-subtitle-desk" style={{marginTop: '-15px'}}>
                        {t('home-page.quickRfq.subtitle', 'Just 3 steps:')}
                    </p>

                    {/* Parrafos para movil */}
                    <p className="quick-rfq-subtitle rfq-subtitle-movil">
                        {t('home-page.quickRfq.subtitle.movil', 'Discover our Quick RFQ tool:')}
                    </p>
                    <p className="quick-rfq-subtitle rfq-subtitle-movil" style={{marginTop: '-15px'}}>
                        {t('home-page.quickRfq.subtitle.movil', 'Get the quotes you need in 3 easy steps.')}
                    </p>
                    
                    <Layout.Row gutter="20"> 
                        <Layout.Col xs={24} sm={8} md={8} className="quick-rfq-step-item">
                            <img 
                                src={rfqStepIcon1} 
                                alt={t('home-page.quickRfq.step1Alt', 'Post RFQ Icon')} 
                                className="quick-rfq-step-icon" 
                            />
                            <p>{t('home-page.quickRfq.step1Description', '1. Post your RFQ with your requirements.')}</p>
                        </Layout.Col>
                        <Layout.Col xs={24} sm={8} md={8} className="quick-rfq-step-item">
                            <img 
                                src={rfqStepIcon2} 
                                alt={t('home-page.quickRfq.step2Alt', 'Receive Quotes Icon')} 
                                className="quick-rfq-step-icon" 
                            />
                            <p>{t('home-page.quickRfq.step2Description', '2. Qualified suppliers will send you tailored quotes.')}</p>
                        </Layout.Col>
                        <Layout.Col xs={24} sm={8} md={8} className="quick-rfq-step-item">
                            <img 
                                src={rfqStepIcon3} 
                                alt={t('home-page.quickRfq.step3Alt', 'Select Option Icon')} 
                                className="quick-rfq-step-icon" 
                            />
                            <p>{t('home-page.quickRfq.step3Description', '3. Review, compare and select the best option.')}</p>
                        </Layout.Col>
                    </Layout.Row>

                    <Link 
                        to="/tools/rfq" // RUTA si es necesario
                        className="el-button el-button--danger quick-rfq-cta" 
                    >
                        <b>{t('home-page.quickRfq.ctaButton', 'CREATE AN QUICK RFQ')}</b>
                        <img src={arrowIcon} alt="" width='22px' className='arrow-icon' />
                        
                    </Link>
                </Layout.Col>

                <Layout.Col xs="24" sm="24" md="12" lg="11" className="quick-rfq-illustration-area">
                    <img 
                        src={rfq} 
                        alt={t('home-page.quickRfq.illustrationAlt', 'RFQ Dashboard Illustration')} 
                        className="quick-rfq-main-illustration" 
                    />
                    <img 
                        src={rfqDashboardIllustration} 
                        alt={t('home-page.quickRfq.illustrationAlt', 'RFQ Dashboard Illustration')} 
                        className="quick-rfq-secundary-illustration" 
                    />
                </Layout.Col>
            </Layout.Row>
            {/* =========== FIN: Sección Quick RFQ =========== */}
            {/* =========== Sección Featured Category =========== */}
            <Layout.Row justify="center" align="middle" className="featured-category-section responsivePadding">
                <Layout.Col span="24">
                    <h2 className="section-title">
                        Featured Category <span className="star-icon">★</span>
                    </h2>
                </Layout.Col>

                <Layout.Row gutter="20" className="featured-category-content">
                    {/* --- Columna Izquierda: Imagen Principal --- */}
                    <Layout.Col xs={24} sm={24} md={12} lg={12}>
                        <div className="featured-category-image-container">
                            <div className="image-placeholder-content">
                            {/* Contenedor con imagen de fondo */}
                            </div>
                        </div>
                    </Layout.Col>

                    {/* --- Columna Derecha: Subcategorías y Botón --- */}
                    <Layout.Col xs={24} sm={24} md={12} lg={12} className="subcategories-column">
                        <Layout.Row gutter="15">
                            <Layout.Col xs={24} sm={12} md={12}>
                                <Link to={`/search-result-ng/${encodeURIComponent("mfcncnmach2506")}/All?tag=${encodeURIComponent("mfcncnmach2506")}`} className="subcategory-item-link">
                                <div className="subcategory-item">
                                    <div className="subcategory-item-inner">
                                        <img src={iconCategory2} alt="CNC Machining Icon" className="subcategory-icon" />
                                        <span>CNC MACHINING</span>
                                    </div>
                                </div>
                                </Link>
                            </Layout.Col>
                            <Layout.Col xs={24} sm={12} md={12}>
                                <Link to={`/search-result-ng/${encodeURIComponent("mfwelnassy2506")}/All?tag=${encodeURIComponent("mfwelnassy2506")}`} className="subcategory-item-link">
                                <div className="subcategory-item">
                                    <div className="subcategory-item-inner">
                                        <img src={iconCategory3} alt="Welding & Metal Assembly Icon" className="subcategory-icon" />
                                        <span>WELDING & METAL ASSEMBLY</span>
                                    </div>
                                </div>
                                </Link>
                            </Layout.Col>
                            <Layout.Col xs={24} sm={12} md={12}>
                                <Link to={`/search-result-ng/${encodeURIComponent("mfshmetal2506")}/All?tag=${encodeURIComponent("mfshmetal2506")}`} className="subcategory-item-link">
                                <div className="subcategory-item">
                                    <div className="subcategory-item-inner">
                                        <img src={iconCategory4} alt="Sheet Metal Cutting Icon" className="subcategory-icon" />
                                        <span>SHEET METAL CUTTING & PROCESSING</span>
                                    </div>
                                </div>
                                </Link>
                            </Layout.Col>
                            <Layout.Col xs={24} sm={12} md={12}>
                                <Link to={`/search-result-ng/${encodeURIComponent("mfcust2506")}/All?tag=${encodeURIComponent("mfcust2506")}`} className="subcategory-item-link">
                                <div className="subcategory-item">
                                    <div className="subcategory-item-inner">
                                        <img src={iconCategory5} alt="Custom Metal Parts Icon" className="subcategory-icon" />
                                        <span>CUSTOM METAL PARTS</span>
                                    </div>
                                </div>
                                </Link>
                            </Layout.Col>
                            <Layout.Col xs={24} sm={12} md={12}>
                                <Link to={`/search-result-ng/${encodeURIComponent("mfbndnfor2506")}/All?tag=${encodeURIComponent("mfbndnfor2506")}`} className="subcategory-item-link">
                                <div className="subcategory-item">
                                    <div className="subcategory-item-inner">
                                        <img src={iconCategory6} alt="Metal Bending & Forming Icon" className="subcategory-icon" />
                                        <span>METAL BENDING & FORMING</span>
                                    </div>
                                </div>
                                </Link>
                            </Layout.Col>
                            <Layout.Col xs={24} sm={12} md={12}>
                                <Link to={`/search-result-ng/${encodeURIComponent("mffinincoat2506")}/All?tag=${encodeURIComponent("mffinincoat2506")}`} className="subcategory-item-link">
                                <div className="subcategory-item">
                                    <div className="subcategory-item-inner">
                                        <img src={iconCategory7} alt="Finishes & Coatings Icon" className="subcategory-icon" />
                                        <span>FINISHES & COATINGS</span>
                                    </div>
                                </div>
                                </Link>
                            </Layout.Col>
                        </Layout.Row>
                        
                        <Link to="/search-result-ng/BAINUBMF009/All" className="go-to-category-btn">
                            <span className="go-to-category-btn-inner">
                                GO TO CATEGORY
                            </span>
                        </Link>
                    </Layout.Col>
                </Layout.Row>
            </Layout.Row>
            {/* =========== FIN: Sección Featured Category =========== */}

            <Layout.Row  justify="center" align="middle" className="responsivePadding suppliersRow">
                <Layout.Col span="24">
                    <h2 className="primary-color m-t-lg">{t('home-page.new-suppliers')}</h2>
                </Layout.Col>

                <SuppliersSwiper
                    slidesPerView={4}
                    spaceBetween={10}
                    suppliers={suppliers}
                    loading={loadingSuppliers}
                    />
            </Layout.Row>

            {/* Blog */}
            {/* =========== INICIO: Sección Blog =========== */}
            <Layout.Row justify="center" className="blog-section responsivePadding">
                <Layout.Col span="24">
                    <h2 className="blog-section-title">Our Blog</h2>
                </Layout.Col>
                <Layout.Row gutter="30" justify="center" className='blog-container'>
                    {blogPosts.map((post, index) => (
                    <Layout.Col key={index} xs={24} sm={12} md={8} lg={7}>
                        <div className="blog-card">
                            
                                <div className="blog-card-content">
                                <img src={post.image} alt={post.title} className="blog-card-image" />
                                    <h3 className="blog-card-title">{post.title}</h3>
                                    <p className="blog-card-meta">{post.date} / {post.readTime}</p>
                                </div>
                            
                            <a href={post.url} target="_blank" rel="noopener noreferrer" className={`blog-card-button ${post.active ? 'active' : ''}`}>
                                GO TO READ
                            </a>
                        </div>
                    </Layout.Col>
                    ))}
                </Layout.Row>
            </Layout.Row>
            {/* =========== FIN: Sección Blog =========== */}

            <Layout.Row className="secondary-form-mp">
                <Layout.Col>
                    <Layout.Row>
                        <Layout.Col>
                        <h1>Do you want to know more about Bainub?</h1>
                        <h3>Receive information about Bainub and support to join our trading network.</h3>
                        </Layout.Col>
                    </Layout.Row>
                    <Layout.Row>
                        <Layout.Col>
                        <RegisterSurvey className="justify-content-left" surveyTitle={t('home-page.product-survey.register-title')} formType={2} />
                        </Layout.Col>
                    </Layout.Row>
                </Layout.Col>
            </Layout.Row>

            {/* Renderiza el fondo solo si el menú móvil está abierto */}
            {isMobileMenuOpen && (
                <div 
                    className="menu-backdrop" 
                    onClick={() => setIsMobileMenuOpen(false)} // se Cierra el menú al hacer clic
                ></div>
            )}
        </>
    )
}
export default Main;